'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Local storage
var localStorageFeatureTest = exports.localStorageFeatureTest = function localStorageFeatureTest() {
    var mod = 'local_storage';
    try {
        localStorage.setItem(mod, mod);
        localStorage.removeItem(mod);
        return true;
    } catch (e) {
        return false;
    }
};

/**
 * A mock to prevent exceptions from being thrown when the local storage is used.
 */
var localStorageMockFallback = {
    getItem: function getItem() {
        return null;
    },
    setItem: function setItem() {
        return null;
    },
    removeItem: function removeItem() {
        return null;
    },
    key: function key() {
        return null;
    },
    length: 0
};

var localStorageService = localStorageFeatureTest() ? localStorage : localStorageMockFallback;

exports.default = localStorageService;


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/localStorage/localStorage.js
// module id = 314
// module chunks = 0